import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { MaterialModule } from 'src/app/material.module';
import { DialogComponent } from 'src/app/shared/dialog/confirm.dialog';

@Component({
  selector: 'app-rc-connect-prompt',
  standalone: true,
  imports: [CommonModule, MaterialModule],
  templateUrl: './rc-connect-prompt.component.html',
  styleUrl: './rc-connect-prompt.component.scss',
})
export class RcConnectPromptComponent {
  constructor(
    private dialogRef: MatDialogRef<RcConnectPromptComponent>,
    private dialog: MatDialog,
  ) {}

  connect(): void {
    this.dialogRef.close('connect');
  }

  dismiss(): void {
    const confirmRef = this.dialog.open(DialogComponent, {
      width: '500px',
      disableClose: true,
      data: {
        header: 'Are you sure?',
        content:
          'You won\'t be able to send SMS from your own RingCentral number until you connect. You can connect later from Settings → My Profile → RingCentral.',
        type: 'warning',
        buttonName: 'Yes, skip for now',
      },
    });

    confirmRef.afterClosed().subscribe((confirmed) => {
      if (confirmed) {
        this.dialogRef.close('dismiss');
      }
    });
  }
}
